// extracted by mini-css-extract-plugin
module.exports = {"externalId":"_2OAFPtpi8uXgS_ji8wSlTs"};